module.exports = fox._r("images/logo_uncolored.png", __webpack_public_path__ + "images/logo_uncolored.png");


//////////////////
// WEBPACK FOOTER
// ./images/logo_uncolored.png
// module id = 558
// module chunks = 2